var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("日均发货量折线图")]),_c('div',{style:({width: '100%', height: '400px'}),attrs:{"id":"Deliver"}})])}
var staticRenderFns = []

export { render, staticRenderFns }